import { userApi } from '../../redux/services/userApi';
import './SettingProfile.scss'
import svg from "../../assets/img/sprite.svg";

export const SettingProfile = () => {

    const { data: userProfile } = userApi.useUserProfileQuery(`/profile`)
    const [logoutUser] = userApi.useLogoutUserMutation();

    const onLogoutHandler = async () => {
        await logoutUser();
        window.location.href = '/';
    }

    const firstLetterName = userProfile?.name.substring(0, 1)
    const firstLetterSurname = userProfile?.surname.substring(0, 1)

    return (
        <section className='setting-profile'>
            <div className='setting-profile__container'>
                <div className='setting-profile__wrap'>
                    <div className='setting-profile__circle'>
                        <span className='setting-profile__firstLette'>{firstLetterName}</span>
                        <span className='setting-profile__firstLette'>{firstLetterSurname}</span>
                    </div>
                    <div className='setting-profile__block'>
                        <span className='setting-profile__name'>Имя Фамилия</span>
                        <span className='setting-profile__user'>{userProfile?.name + ' ' + userProfile?.surname}</span>
                    </div>
                </div>
                <div className='setting-profile__wrap'>
                    <div className='setting-profile__circle'>
                        <svg className="btn__like" width="22" height="18">
                            <use xlinkHref={`${svg}#emailProfile`}></use>
                        </svg>
                    </div>
                    <div className='setting-profile__block'>
                        <span className='setting-profile__name'>Электронная почта</span>
                        <span className='setting-profile__user'>{userProfile?.email}</span>
                    </div>
                </div>

            </div>
            <button className='btn btn-blue' onClick={onLogoutHandler}>Выйти из аккаунта</button>
        </section>
    )
}

